import client from './client';

const techActivityUrl = '/api/v1/techActivity';

export const getActivityList = (usrUuid, searchDate) => {
  return client.get(`${techActivityUrl}/list`, {
    params: { usrUuid, searchDate }
  });
};

export const getActivityDetail = (activityId) => {
  return client.get(`${techActivityUrl}/${activityId}`);
};

export const saveTechActivity = (finalData) => {
  return client.post(`${techActivityUrl}/save`, finalData);
};

export const deleteTechActivity = (params) => {
  return client.post(`${techActivityUrl}/delete`, params);
};
